import { type FC } from "react"
import { useForm } from "react-hook-form"

import { CostBreakdownFilter } from "./CostBreakdownFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"
import { GoodsReceiptWarehouseFilter } from "@/screens/WarehouseReceiving/components/GoodsReceiptsTable/GoodsReceiptWarehouseFilter"
import type { GoodsReceiptFilterFormValues } from "@/screens/WarehouseReceiving/types"
import type { Option } from "@/types/form-fields"

interface CostBreakdownFilterFormValues extends GoodsReceiptFilterFormValues {
  isProductCostCompleted?: boolean[]
}

interface CostBreakdownFilterDrawerProps {
  isOpen: boolean
  warehouseAreaIds: string[]
  warehouseOptions: Option<string>[]
  isWarehousesFetching: boolean
  isProductCostCompleted?: boolean[]
  onToggle: () => void
  onChange: (warehouseIds: string[]) => void
  onCostBreakdownChange: (isProductCostCompleted?: boolean[]) => void
  onClear: () => void
}

export const CostBreakdownFilterDrawer: FC<CostBreakdownFilterDrawerProps> = ({
  isOpen,
  warehouseAreaIds,
  warehouseOptions,
  isWarehousesFetching,
  isProductCostCompleted,
  onToggle,
  onChange,
  onCostBreakdownChange,
  onClear,
}) => {
  const { control } = useForm<CostBreakdownFilterFormValues>({
    defaultValues: {
      warehouseAreaIds,
      isProductCostCompleted,
    },
  })

  return (
    <SearchFilterDrawer open={isOpen} toggleDrawer={onToggle} clear={onClear} testId='cost-breakdown-filter-drawer'>
      <CostBreakdownFilter control={control} selectedValues={isProductCostCompleted} onChange={onCostBreakdownChange} />
      <GoodsReceiptWarehouseFilter
        control={control}
        isFetching={isWarehousesFetching}
        options={warehouseOptions}
        selectedValues={warehouseAreaIds}
        onChange={onChange}
      />
    </SearchFilterDrawer>
  )
}
